/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Col_CaseInputs */

const en_tasks_col_case = /** @type {(inputs: Tasks_Col_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

const pt_br2_tasks_col_case = /** @type {(inputs: Tasks_Col_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso`)
};

/**
* | output |
* | --- |
* | "Case" |
*
* @param {Tasks_Col_CaseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_col_case = /** @type {((inputs?: Tasks_Col_CaseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Col_CaseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_col_case(inputs)
	return pt_br2_tasks_col_case(inputs)
});